export const styleElements = {
  statusConfirmStyle: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#D9F7BE",
    color: "#52C41A",
    padding: "6px 12px",
    borderRadius: "8px",
    fontSize: "11px",
    fontWeight: 500,
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statusYetConfirmStyle: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#FFCCC7",
    color: "#F5222D",
    padding: "6px 12px",
    borderRadius: "8px",
    fontSize: "11px",
    fontWeight: 500,
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
